import { useEffect, useState } from "react";
import clsx from "clsx";

// Interfaces
import { ICommissionCap } from "./interfaces";

// Custom components
import CustomizedSwitches from "@/Layouts/components/InputComponents/CustomizedSwitches";
import InputValue from "@/Layouts/components/InputComponents/InputValue";

// MUI
import { Grid, Typography } from "@mui/material";

export default function CommissionCap(props: Readonly<ICommissionCap>) {
	const { value, enabled = false, readOnly = false, onUpdateCapSwitch = () => {}, onUpdateCapValue = () => {} } = props;

	const [checked, setChecked] = useState(false);

	useEffect(() => {
		setChecked(enabled);

		return () => {
			setChecked(false);
		};
	}, [enabled]);

	return (
		<Grid container alignItems="center">
			<Grid item xs={5}>
				<CustomizedSwitches
					disabled={readOnly}
					textRight
					textChecked="Enable Cap"
					textUnChecked="Enable Cap"
					onChange={(val) => {
						setChecked(val);
						onUpdateCapSwitch?.(val);
					}}
					checked={checked}
				/>
			</Grid>
			<Grid item xs={1}>
				<Typography
					className={clsx({
						"cap-label": true,
						"!text-disabled": readOnly,
					})}
				>
					Cap
				</Typography>
			</Grid>
			<Grid item xs={3}>
				<InputValue
					readOnly={readOnly || !checked}
					value={value || 0}
					data={[
						{
							type: "Dollar",
							min: 0,
							max: 5000,
							decimals: 2,
							decimalsEditable: false,
							disabled: !checked,
						},
					]}
					sx={{ width: "95px" }}
					onActionUpdate={onUpdateCapValue}
				/>
			</Grid>
		</Grid>
	);
}
